import { AdminApi } from './AdminApi';
import { Category } from './Category';
import { Method } from './ContentApi';
import { RestContentApi } from './RestContentApi';
import { UserRole } from './sessionSlice';

type LoginResponseJson = {
  role: 'viewer' | 'admin' | 'root';
};

type UpdatePostContentResponseJson = {
  en?: string;
  it?: string;
};

export class RestAdminApi extends RestContentApi implements AdminApi {
  async testLogin() {
    return this.doLogin('GET', {});
  }

  async login(username: string, password: string) {
    const data = new FormData();
    data.append('username', username);
    data.append('password', password);
    return this.doLogin('POST', { body: data });
  }

  private async doLogin(method: Method, init: RequestInit): Promise<UserRole> {
    const url = `${this.endpoint}/session`;
    const response = await this.request(url, method, init);
    if (response.status === 200) {
      return this.readUserRole(response.json as LoginResponseJson);
    } else {
      const error = response.json as { error: string };
      throw new Error(error.error);
    }
  }

  async logout(): Promise<UserRole> {
    const url = `${this.endpoint}/session`;
    const response = await this.request(url, 'DELETE');
    if (response.status === 200) {
      return this.readUserRole(response.json as LoginResponseJson);
    } else {
      const error = response.json as { error: string };
      throw new Error(error.error);
    }
  }

  async updatePostContent(
    category: Category,
    slug: string,
    content: { en?: string; it?: string }
  ): Promise<{ en: string; it: string }> {
    const url = `${this.endpoint}/posts/${category}/${slug}/content`;
    const response = await this.request(url, 'PUT', { body: JSON.stringify(content) });
    if (response.status === 200) {
      const body = response.json as UpdatePostContentResponseJson;
      return { en: body.en, it: body.it };
    } else {
      const error = response.json as { error: string };
      throw new Error(error.error);
    }
  }

  private readUserRole(response: LoginResponseJson) {
    const role = response.role;
    switch (role) {
      case 'viewer':
        return UserRole.Viewer;
      case 'admin':
        return UserRole.Admin;
      case 'root':
        return UserRole.Root;
      default:
        throw new Error(`Bad user role: ${role}`);
    }
  }
}
